import type { CSSProperties } from 'react';
import { createGlobalStyle } from 'styled-components';

export const COLOR_CONFLICT = '#e74c03';

export const fullSize: CSSProperties = {
  width: '100%',
  height: '100%',
};

export const contain: CSSProperties = {
  contain: 'strict',
};

export const TIMELINE_COLORS = {
  backgroundGray: '#e2e4e7',
  headerDark: '#202633',
  headerLight: '#ebeef3',
  controlBackground: '#919ca3',
  suggestionButton: '#149222',
  regionToggleBackground: '#ffe552',
  sidebarDark: '#474a4e',
  sidebarBorder: '#c5cdd9',
  weekendBackground: 'rgba(34, 35, 35, 0.078)',
} as const;

export const TimelineStyle = createGlobalStyle`
  .react-calendar-timeline {
    position: relative; // Required for scrolling to function properly
    font-size: 0.875rem;
    font-weight: 400;
    font-family: 'Inter', 'Space Grotesk', 'Helvetica', fallback-font, sans-serif;
    width: 100%;
  }
  .react-calendar-timeline .rct-sidebar {
    padding: 0;
  }
  .react-calendar-timeline .rct-calendar-header {
    border: none;
  }
  .react-calendar-timeline .rct-sidebar-header,
  .react-calendar-timeline .rct-header .rct-label-group {
    color: hsla(0, 0%, 100%, 0.8);
    text-transform: uppercase;
    background-color: ${TIMELINE_COLORS.headerDark};
    align-items: center;
    display: flex;
    border: none;
  }
  .react-calendar-timeline .rct-scroll {
    border-left: 1px solid #848EA0;
  }
  .react-calendar-timeline .rct-scroll {
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
  }
  .react-calendar-timeline .rct-scroll::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  .react-calendar-timeline .rct-horizontal-lines .rct-hl-even,
  .react-calendar-timeline .rct-horizontal-lines .rct-hl-odd {
    border-top: 1px solid white;
    border-bottom: 1px solid rgb(177,188,200);
  }
  .react-calendar-timeline .rct-horizontal-lines .rct-hl-odd {
    background-color: ${TIMELINE_COLORS.backgroundGray};
  }
  .react-calendar-timeline .rct-vertical-lines .rct-vl {
    border-left: 1px solid hsla(0, 0%, 100%, 0.23);
  }

  .react-calendar-timeline .rct-header .rct-label-group {
    border-bottom: none;
  }

  .react-calendar-timeline .rct-header .rct-label {
    color: hsla(0, 0%, 100%, 0.8);
    background-color: ${TIMELINE_COLORS.headerDark};
  }
  .react-calendar-timeline .rct-header-root,
  .react-calendar-timeline .rct-dateHeader {
    color: hsla(0, 0%, 100%, 0.8);
    background-color: ${TIMELINE_COLORS.headerDark};
    text-transform: uppercase;
    border-bottom: none;
    border-left: none;
  }

  .react-calendar-timeline .rct-dateHeader-primary {
    background-color: initial;
    border-right: none;
    border-left: none;
    color: #fff;
  }

  .limit-width .react-calendar-timeline .rct-header-container.header-sticky div + div,
  .limit-width .react-calendar-timeline .rct-scroll {
    max-width: calc(100vw - 455px);
  }

  .react-calendar-timeline .rct-item .rct-item-content {
    overflow: visible;
  }

  .rct-item-content div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .rct-item-content div:hover {
    overflow: visible;
    position: static;
    z-index: 1000;
  }

  .react-calendar-timeline .rct-calendar-header {
    border-bottom: 1px solid #0a1722;
  }

  .react-calendar-timeline .rct-sidebar {
    color: #000;
    border-right: 1px solid #556883;
  }

  .react-calendar-timeline .rct-sidebar-header,
  .react-calendar-timeline .rct-header .rct-label-group {
    color: #000;
    background-color: ${TIMELINE_COLORS.headerLight};
  }

  .react-calendar-timeline .rct-scroll {
    background-color: ${TIMELINE_COLORS.backgroundGray};
  }

  .react-calendar-timeline .rct-header .rct-label {
    color: #000;
    background-color: ${TIMELINE_COLORS.headerLight};
  }

  .react-calendar-timeline .rct-header-root,
  .react-calendar-timeline .rct-dateHeader {
    color: #ffffff;
    background-color: ${TIMELINE_COLORS.sidebarDark};
    font-size: 0.75rem;
    font-weight: bold;
    align-items: flex-start;
    justify-content: flex-start;
    border-left: 1px solid ${TIMELINE_COLORS.sidebarBorder};
  }

  .react-calendar-timeline .rct-dateHeader span {
    display: inline-block;
    padding-left: 5px;
  }

  .react-calendar-timeline .rct-dateHeader-primary {
    color: #ffffff;
  }

  .react-calendar-timeline .year-month-header .rct-dateHeader:after {
    border-left: 1px solid ${TIMELINE_COLORS.sidebarBorder};
    content: '';
    display: block;
    height: 100%;
    left: -1px;
    position: absolute;
    top: 100%;
    width: 1px;
    z-index: 1;
  }

  .react-calendar-timeline .year-month-header .rct-dateHeader > span {
    position: sticky;
    left: 0;
    margin-right: 8px;
  }
  .react-calendar-timeline .date-time-header .rct-dateHeader {
    white-space: nowrap;
  }

  .react-calendar-timeline .rct-sidebar .rct-sidebar-row {
    overflow: initial;
  }

  .react-calendar-timeline .rct-sidebar .rct-sidebar-row,
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row.rct-sidebar-row-even,
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row.rct-sidebar-row-odd {
    padding: 0;
    border-top: 1px solid white;
    border-bottom: 1px solid rgb(177,188,200);
    font-size: 0.875rem;
  }
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row.rct-sidebar-row-odd {
    background-color: ${TIMELINE_COLORS.backgroundGray};
  }
  .react-calendar-timeline .rct-sidebar .rct-sidebar-row.rct-sidebar-row-even {
    background-color: ${TIMELINE_COLORS.backgroundGray};
  }

  .react-calendar-timeline .rct-vertical-lines .rct-vl.dark {
    border-left: 1px solid rgba(0, 0, 0, 0.15);
  }

  .react-calendar-timeline .rct-vertical-lines .rct-vl {
    border-left: 1px solid rgba(9, 44, 79, 0.251);
  }

  .react-calendar-timeline .rct-vertical-lines .rct-vl.rct-day-6 {
    background-color: ${TIMELINE_COLORS.weekendBackground};
  }

  .react-calendar-timeline .rct-vertical-lines .rct-vl.rct-day-0 {
    background-color: ${TIMELINE_COLORS.weekendBackground};
  }
`;
